import { compose, withState } from 'recompose';
import ScheduleRecurringCampaignHeader from '../components/ScheduleRecurringCampaignHeader';

const ScheduleRecurringCampaignHeaderContainer = compose(
  withState('showMoreInfo', 'setShowMoreInfo', false),
)(ScheduleRecurringCampaignHeader);

export default ScheduleRecurringCampaignHeaderContainer;
